import request from '@/utils/request'

/***
 *
 *
 *
 *
 * @param query
 * @returns {*}
 */
// 查询后端枚举配置
export function getEnumByClassFullName(fullClassPath) {
    return request({
        url: '/app/common/getEnumsByPath?classFullName=' + fullClassPath,
        method: 'get',
      async: false
    })
}
